module.exports = __webpack_public_path__ + "img/phone.ba7c1d34.svg";